import { Card, CardContent, Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import { WsBreadCrumbs } from '../../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../../features/teams/helper/defaultValues';
import { AutomatedEmailCampaignChildRoutes } from '../../childRoutes';
import { automatedNavigationOptions } from '../../utils';

import { SideNavBarContainer } from './SideNavBarContainer';

export const AutomatedEmailCampaignLayout = () => (
  <Grid>
    <WsBreadCrumbs
      breadCrumbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.CRM,
        Pages['DEFAULT_AUTOMATED_EMAIL_CAMPAIGN']
      )}
    />
    <Card sx={{ my: 1, p: 1.5, width: '70%' }}>
      <WsTypography variant={WsTypoVariants.TITLE} bold>
        Automated Email Campaign
      </WsTypography>
    </Card>
    <Grid display="flex" gap={2}>
      <Grid
        xs={2}
        sx={{
          borderRadius: 1.2,
          height: '40%',
        }}
      >
        <SideNavBarContainer sideMenuOptions={automatedNavigationOptions} />
      </Grid>
      <Grid item xs={10}>
        <Card>
          <CardContent sx={{ p: 3 }}>
            <AutomatedEmailCampaignChildRoutes />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  </Grid>
);
